// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2KozF","emails":"CreateEditClinics_emails__cG0Qu","emailTagLabel":"CreateEditClinics_emailTagLabel__17ppx"};